import React, { Component } from 'react';
import PropTypes from 'prop-types';
import QueryString from 'qs';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import DataList from 'components/ui/DataList';
import SessionStore from 'stores/SessionStore';
import CustomerSearch from 'components/site/customer-search-alt';
import CustomersStore from 'stores/CustomerDetailsStore';
import CustomersActionCreators from 'actions/CustomersActionCreators';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import CargomaticPane from 'components/v2/pane';
import QuoteSearch from './quoteSearch';
import CreateQuoteStore from '../../../stores/quotes/CreateQuoteStore';
import DeleteQuoteStore from '../../../stores/quotes/DeleteQuoteStore';
import Mapping from './Mapping';
import ConfirmModal from '../../ui/modals/ConfirmModal';
import QuoteModal from './QuoteModal';
import QuoteDetail from './QuoteDetail';
import Container from '../../v2/container';
class QuotesTable extends Component {
    constructor(props) {
        super(props);
        this.handlePaginationSelect = (page) => {
            this.setState((prevState) => {
                const filters = Object.assign(Object.assign({}, prevState.filters), { page });
                return {
                    filters,
                };
            }, () => this.fetchQuotes(this.state.shipper._id));
        };
        this.handleDelete = (quoteToDelete) => this.setState({
            quoteToDelete,
            showConfirmModal: true,
        });
        this.handleEdit = (quoteToEdit) => {
            this.setState({
                quoteToEdit,
            }, () => CustomersActionCreators.fetchQuote(quoteToEdit));
        };
        this.handleCancelConfirm = () => this.setState({
            quoteToDelete: null,
            showConfirmModal: false,
        });
        this.handleConfirmDelete = () => {
            ShipmentsActionCreators.deleteQuote(this.state.quoteToDelete);
            this.setState({
                quoteToDelete: null,
                showConfirmModal: false,
            });
        };
        this.refreshQuotes = () => {
            if (this.state.shipper) {
                this.fetchQuotes(this.state.shipper._id);
            }
            else {
                this.fetchQuoteById(this.state.quotes[0]._id);
            }
        };
        this.handleShowDetailPane = (selectedQuote) => this.setState({
            showDetailPane: true,
            selectedQuote,
        });
        this.handleRowSelect = (row) => {
            this.handleShowDetailPane(row);
        };
        this.handleHideDetailPane = () => {
            this.setState({ showDetailPane: false, selectedQuote: null }, () => {
                this.props.history.push({
                    pathname: '/quotes',
                    search: `?shipper_id=${this.state.shipper._id}`,
                });
            });
        };
        this.handleShowQuoteModal = () => this.setState({ quoteToEdit: null, showQuoteModal: true });
        this.handleHideQuoteModal = () => {
            this.setState({ showQuoteModal: false });
        };
        this.handleIncomingQuotes = () => {
            const result = CustomersStore.getShipperQuotes();
            const { quotes, pages, total_entries } = result;
            this.setState({ quotes, pages, totalCount: total_entries });
        };
        this.handleShipperFetched = () => {
            const shipper = CustomersStore.getShipper();
            if (!shipper) {
                return null;
            }
            const { _id, company_name } = CustomersStore.getShipper();
            this.setState({
                shipper: {
                    _id,
                    company_name,
                },
            });
        };
        this.handleQuoteFetched = () => {
            const state = CustomersStore.getQuoteRequestState();
            if (state.success) {
                const selectedQuote = CustomersStore.getQuote();
                const { shipper } = selectedQuote;
                if (this.state.quoteToEdit) {
                    return this.setState({
                        quoteToEdit: selectedQuote,
                        showQuoteModal: true,
                    });
                }
                const parsed = QueryString.parse(this.props.location.search);
                if (!parsed.shipper_id) {
                    this.props.history.push({
                        search: `?shipper_id=${shipper._id}`,
                    });
                    this.fetchQuotes(shipper._id);
                }
                this.setState({
                    selectedQuote,
                    shipper,
                    showDetailPane: true,
                });
            }
        };
        this.handleShipperFieldChange = (value) => {
            this.setState({ shipperInput: value });
        };
        this.handleShipperSelect = (value, item) => {
            this.setState({ shipper: item, quotes: [], selectedQuote: null });
            this.fetchQuotes(item._id);
            this.props.history.push({
                search: `?shipper_id=${item._id}`,
            });
        };
        this.handleSearchFieldChange = (value) => {
            this.setState({ searchInput: value });
        };
        this.handleSearchSelect = (value, item) => {
            this.setState({ quotes: [item], selectedQuote: item });
        };
        const user = SessionStore.getUser();
        const { t } = this.props;
        let columns;
        if (user._type === 'Shipper') {
            columns = Mapping.columns.shipper.map((col) => (Object.assign(Object.assign({}, col), { text: titleize(t(col.text, { count: (col === null || col === void 0 ? void 0 : col.count) || 1 })) })));
        }
        else {
            columns = [...Mapping.columns.admin];
        }
        const lastIndex = columns.length - 1;
        columns[lastIndex].formatExtraData = {
            onDelete: this.handleDelete,
            onEdit: this.handleEdit,
        };
        this.state = {
            selectedQuote: null,
            showConfirmModal: false,
            quoteToDelete: null,
            quoteToEdit: null,
            userRole: user._type,
            shipper: user._type === 'Shipper' ? user : null,
            quotes: [],
            shipperInput: '',
            searchInput: '',
            showQuoteModal: false,
            showDetailPane: false,
            columns,
            can_view_quotes: !!user.can_view_quotes,
            filters: {
                page: 1,
                per_page: 25,
            },
            pages: 1,
            totalCount: 0,
            // columns: (user._type === 'Shipper') ? Mapping.columns.shipper : Mapping.columns.admin,
        };
    }
    componentDidMount() {
        CustomersStore.addQuotesChangeListener(this.handleIncomingQuotes);
        CustomersStore.addQuoteChangeListener(this.handleQuoteFetched);
        CustomersStore.addChangeListener(this.handleShipperFetched);
        CreateQuoteStore.addChangeListener(this.refreshQuotes);
        DeleteQuoteStore.addChangeListener(this.refreshQuotes);
        // Only for shipper flow
        if (this.state.shipper) {
            this.fetchQuotes(this.state.shipper._id);
        }
        if (this.props.match.params.id) {
            CustomersActionCreators.fetchQuote(this.props.match.params.id);
        }
        const parsed = QueryString.parse(this.props.location.search, {
            ignoreQueryPrefix: true,
        });
        const shouldFetchShipperQuotes = (!this.state.shipper ||
            (this.state.shipper && this.state.shipper._id !== parsed.shipper_id)) &&
            !!parsed.shipper_id;
        if (shouldFetchShipperQuotes) {
            this.fetchQuotes(parsed.shipper_id);
            CustomersActionCreators.getShipper(parsed.shipper_id);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!nextProps.match.params.id) {
            this.setState({ selectedQuote: null, showDetailPane: false });
            return;
        }
        if (nextProps.match.params.id &&
            this.props.match.params.id !== nextProps.match.params.id) {
            CustomersActionCreators.fetchQuote(nextProps.match.params.id);
        }
    }
    componentWillUnmount() {
        CustomersStore.removeQuotesChangeListener(this.handleIncomingQuotes);
        CustomersStore.removeQuoteChangeListener(this.handleQuoteFetched);
        CustomersStore.removeChangeListener(this.handleShipperFetched);
        CreateQuoteStore.removeChangeListener(this.refreshQuotes);
        DeleteQuoteStore.removeChangeListener(this.refreshQuotes);
    }
    fetchQuotes(shipperId) {
        CustomersActionCreators.fetchQuotesByShipper(shipperId, this.state.filters);
    }
    fetchQuoteById(quoteId) {
        CustomersActionCreators.fetchQuoteAfterUpdate(quoteId);
    }
    getDetailComponent() {
        const { selectedQuote } = this.state;
        return React.createElement(QuoteDetail, { quote: selectedQuote });
    }
    renderPane() {
        const { t } = this.props;
        if (!this.state.showDetailPane) {
            return null;
        }
        return (React.createElement(CargomaticPane, { show: this.state.showDetailPane, title: t('QUOTE_DETAILS'), onHide: this.handleHideDetailPane, renderBody: () => this.getDetailComponent(), location: "right", className: "sm:w-1/3 sm:max-w-none" }));
    }
    renderShipperFilter() {
        const { t } = this.props;
        // Shipper filter only visible to admins
        if (this.state.userRole !== 'Admin') {
            return null;
        }
        return (React.createElement("fieldset", { className: "px-2" },
            React.createElement("div", { className: "mb-4 customer-search" },
                React.createElement(CustomerSearch, { clearOnSelect: true, onChange: this.handleShipperFieldChange, onSelect: this.handleShipperSelect, value: this.state.shipperInput, placeholder: t('SEARCH_FOR_SHIPPER'), type: "shippers" }))));
    }
    renderQuotesFilter() {
        const { t } = this.props;
        return (React.createElement("fieldset", { className: "px-2" },
            React.createElement("div", { className: "mb-4 customer-search" },
                React.createElement(QuoteSearch, { clearOnSelect: true, onChange: this.handleSearchFieldChange, onSelect: this.handleSearchSelect, value: this.state.searchInput, placeholder: t('SEARCH_FOR_QUOTES'), type: "quotes", shipper: this.state.shipper }))));
    }
    render() {
        const isShipper = SessionStore.isShipper();
        const { can_view_quotes } = this.state;
        const { t } = this.props;
        if (isShipper && !can_view_quotes) {
            return (React.createElement("div", null,
                React.createElement("h3", null, t('QUOTES_ACCESS_DISABLED'))));
        }
        return (React.createElement(Container, null,
            React.createElement("div", { className: "relative mt-10" },
                React.createElement("div", null,
                    React.createElement("div", { className: "flex flex-wrap justify-between items-center header" },
                        React.createElement("h3", { className: "mt-0 mb-0 mr-2" }, t('SHIPMENT_QUOTES')),
                        this.state.shipper && (React.createElement("div", { className: "flex items-center sm:-mx-2" },
                            React.createElement("div", { className: "flex sm:px-2" },
                                React.createElement("b", null, t('SHOWING_QUOTES', {
                                    showingQuotes: this.state.quotes.length,
                                }))),
                            React.createElement("div", { className: "flex-none sm:px-2" },
                                React.createElement("button", { title: t('QUOTE_WIZARD'), className: "flex items-center ml-5 text-white button bg-green quotes-quotesTable-newQuote heap", onClick: this.handleShowQuoteModal }, t('NEW_QUOTE')))))),
                    React.createElement("div", { className: "" },
                        !isShipper && (React.createElement("div", { className: "flex my-4" },
                            React.createElement("span", { className: "mr-2 font-bold" },
                                t('SELECTED_SHIPPER'),
                                ":"),
                            React.createElement("span", null, this.state.shipper
                                ? this.state.shipper.company_name
                                : t('NONE')))),
                        this.state.selectedQuote && (React.createElement("div", { className: "flex mt-2" },
                            React.createElement("span", { className: "mr-2 font-bold" },
                                t('SELECTED_QUOTE'),
                                ":"),
                            React.createElement("span", null, this.state.selectedQuote.quote_id)))),
                    React.createElement("div", { className: "flex flex-wrap -mx-2" },
                        this.renderShipperFilter(),
                        this.renderQuotesFilter())),
                this.state.quotes.length > 0 ? (React.createElement("div", { className: "bg-white rounded shadow p-4" },
                    React.createElement(DataList, { striped: true, showHeaders: true, clickToSelect: true, onSelect: (row, selected) => this.handleSelectRow(row, selected), paginate: true, data: this.state.quotes, page: this.state.filters.page, pages: this.state.pages, total: this.state.totalCount, perPage: this.state.filters.per_page, columns: this.state.columns, onPaginationSelect: this.handlePaginationSelect, onSelectAll: () => { } }))) : (React.createElement("div", { className: "" }, t('NOT_SHIPPER_QUOTES'))),
                React.createElement("div", null,
                    React.createElement("p", { className: "mt-8 text-sm italic text-gray-500" }, t('DESCRIPTION_QUOTES_NOTE'))),
                React.createElement("div", { id: "pane-container" }, this.renderPane()),
                this.state.showQuoteModal && (React.createElement(QuoteModal, { show: this.state.showQuoteModal, onHide: this.handleHideQuoteModal, shipper: this.state.shipper, quote: this.state.quoteToEdit })),
                this.state.showConfirmModal && (React.createElement(ConfirmModal, { title: t('CONFIRM_DELETE'), message: t('REMOVE_QUOTE_WARNING'), hideButtonText: titleize(t('CANCEL')), affirmative: t('OK').toUpperCase(), show: this.state.showConfirmModal, onHide: this.handleCancelConfirm, onConfirm: this.handleConfirmDelete })))));
    }
}
QuotesTable.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string,
    }),
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }).isRequired,
};
export default withTranslation()(QuotesTable);
